const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'irisnet',
    assets: [{
            description: 'The IRIS token is the native governance token for the IrisNet chain.',
            denom_units: [{
                    denom: 'uiris',
                    exponent: 0
                }, {
                    denom: 'iris',
                    exponent: 6
                }],
            base: 'uiris',
            name: 'IRISnet',
            display: 'iris',
            symbol: 'IRIS',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg'
            },
            coingecko_id: 'iris-network',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/irisnet/images/iris.svg',
                    theme: {
                        primary_color_hex: '#5664ad'
                    }
                }]
        }]
};
export default info;
